<template>
  <div class="mt-5">
    <swiper-container
    :pagination="{
      clickable: true
    }">
      <main-slider-slide
        :title="getSlide1Title"
        :text="getSlide1Text"
        btnText="Подробнее"
        linkPath = "/about"
        LinkName="AboutRAAIPage"
      />
      <main-slider-slide
        :title="getSlide2Title"
        :text="getSlide2Text"
        btnText="Подробнее"
        linkPath = "/all_partners"
        LinkName="AllPartnersPage"
      />
    </swiper-container>
  </div>  
</template>
  
<script>
  import MainSliderSlide from './MainSliderSlide.vue'
  import { useMainSliderStore } from '@/store/mainSlider'
  export default {
    name: 'MainSlider',
    components: { MainSliderSlide},
    data(){
      useMainSliderStore().getAllSlides()
    },
    mounted() {
      this.$nextTick(() => {
        let swiperContainer = document.querySelector('swiper-container');
        let shadowRoot = swiperContainer.shadowRoot
        let shadowRootDiv = shadowRoot.children[0]
        let swiperPagination = shadowRootDiv.querySelector('.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal')
        swiperPagination.style.position = 'static'
        swiperPagination.style.setProperty('margin-top','40px')
        swiperPagination.style.setProperty('margin-bottom','32px')
      })
    },
    computed:{
      getSlide1Title(){
        let slides = useMainSliderStore().getSlides
        if (slides.length > 0){
          return slides[0].title
        }
        return ''
      },
      getSlide1Text(){
        let slides = useMainSliderStore().getSlides
        if (slides.length > 0){
          return slides[0].text
        }
        return ''
      },
      getSlide2Title(){
        let slides = useMainSliderStore().getSlides
        if (slides.length > 1){
          return slides[1].title
        }
        return ''
      },
      getSlide2Text(){
        let slides = useMainSliderStore().getSlides
        if (slides.length > 1){
          return slides[1].text
        }
        return 'Всероссийская творческая профессиональная организация - создана на основе Советской ассоциации искусственного интеллекта и зарегистрирована Минюстом РФ 19.10.92 №1304. Ассоциация объединяет в своих рядах ученых России и многих ученых из стран СНГ, областью профессиональной деятельности которых является искусственный интеллект'
      },
    },
  };

</script>